import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["error", "className", "title", "caption", "required", "placeholder", "defaultValue", "textSecurity", "allowChanged", "forbidChange"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import styles from "@/styles/Form.module.scss";
import classnames from "classnames";
import { forwardRef, useMemo } from "react";
import ErrorMessage from "./ErrorMessage";
import { usePreventContextMenu } from "@/hooks";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TextField = /*#__PURE__*/forwardRef((props, ref) => {
  const {
      error,
      className,
      title,
      caption,
      required,
      placeholder,
      defaultValue,
      textSecurity = false,
      allowChanged,
      forbidChange
    } = props,
    _props = _objectWithoutProperties(props, _excluded);
  const [on, off] = usePreventContextMenu();
  const defaultValueProps = useMemo(() => {
    const _defaultValue = (() => {
      if (_props !== null && _props !== void 0 && _props.value) return null;
      if (defaultValue) return defaultValue;
      return "";
    })();
    const props = {};
    if (_defaultValue) {
      props.defaultValue = _defaultValue;
    }
    return props;
  }, [_props === null || _props === void 0 ? void 0 : _props.value, defaultValue]);
  return /*#__PURE__*/_jsxs("div", {
    className: styles.inputField,
    children: [title && /*#__PURE__*/_jsx("legend", {
      className: classnames(styles.formTitle, {
        [styles.required]: required,
        [styles.allowChanged]: allowChanged,
        [styles.forbidChange]: forbidChange
      }),
      children: title
    }), /*#__PURE__*/_jsx("input", _objectSpread(_objectSpread({
      ref: ref,
      type: "text",
      placeholder: placeholder,
      className: classnames(styles.textInput, className, {
        [styles.textSecurity]: textSecurity
      }),
      required: required,
      onFocus: off,
      onBlur: on
    }, _props), defaultValueProps)), error && /*#__PURE__*/_jsx(ErrorMessage, {
      msg: error
    }), caption && /*#__PURE__*/_jsx("p", {
      className: styles.textInputCaption,
      children: caption
    })]
  });
});
TextField.displayName = "TextField";
export default TextField;